import React from 'react';
import { Popup, TextInput } from '@leverege/ui-elements';
import { jsx as _jsx } from "react/jsx-runtime";
export default class StringComparatorValueEditor extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      search: props.value,
      opened: false,
      suggestions: []
    };
    this.searchCharacterMin = props.searchCharacterMin != null ? props.searchCharacterMin : 0;
  }
  onTogglePopup = ({
    isOpened
  }) => {
    this.setState({
      opened: isOpened
    });
  };
  onSearch = ({
    value
  }) => {
    const {
      suggestor
    } = this.props;
    this.setState({
      search: value
    }, async () => {
      if (value?.length >= this.searchCharacterMin) {
        const suggestions = suggestor && (await suggestor.suggest(value)) || [];
        this.setState({
          suggestions: suggestions.map(s => {
            return typeof s === 'object' ? s : {
              value: s,
              name: s
            };
          }),
          opened: suggestions.length > 0
        });
      }
    });
  };
  onChange = ({
    value,
    data
  }) => {
    const {
      onChange,
      eventData
    } = this.props;
    onChange?.({
      data: eventData,
      value
    });
    this.setState({
      opened: data !== 'select',
      search: value
    });
  };
  onKeyPress = evt => {
    const {
      search
    } = this.state;
    if (evt.key === 'Enter') {
      this.onChange({
        value: search
      });
    }
  };
  onFocus = () => {
    const {
      suggestions,
      search
    } = this.state;
    if (suggestions.length > 0) {
      this.setState({
        opened: true
      });
    } else if (search && search.length > this.searchCharacterMin) {
      this.onSearch({
        value: search
      });
    }
  };
  onBlur = () => {
    const {
      search,
      suggestions
    } = this.state;
    if (!suggestions || suggestions.length === 0) {
      this.onChange({
        value: search
      });
    }
  };
  renderTrigger = ({
    ref,
    setOpened
  }) => {
    const {
      eventData,
      onChange,
      value,
      suggestor,
      searchCharacterMin,
      ...rest
    } = this.props;
    const {
      search
    } = this.state;
    return /*#__PURE__*/_jsx(TextInput, {
      ...rest,
      domRef: ref,
      onFocus: this.onFocus,
      onBlur: this.onBlur,
      onKeyDown: this.onKeyPress,
      changeOnReturn: false,
      alwaysFireOnReturn: false,
      value: search,
      eventData: eventData,
      onChange: this.onSearch
    });
  };
  renderPopup = () => {
    const {
      suggestions
    } = this.state;
    return suggestions == null ? null : suggestions.map(suggestion => /*#__PURE__*/_jsx(Popup.Item, {
      eventData: "select",
      value: suggestion.value,
      onClick: this.onChange,
      children: suggestion.name
    }, suggestion.value));
  };
  render() {
    const {
      variant
    } = this.props;
    const {
      opened
    } = this.state;
    const v = variant || 'condition';
    return /*#__PURE__*/_jsx(Popup, {
      variant: v,
      opened: opened,
      onChange: this.onTogglePopup,
      navBehavior: "trigger",
      trigger: this.renderTrigger,
      render: this.renderPopup
    });
  }
}